/* eslint-disable no-use-before-define */
import { querySelectArray } from './utils';

const KEYS = {
    ENTER: 13,
    SPACE: 32,
};

const InitVideos = () => {
    initVideoTranscriptControls();
    document.addEventListener('pjax:complete', initVideoTranscriptControls); // DOMContent
};

function initVideoTranscriptControls() {
    const videoTranscripts = querySelectArray(
        '[data-video-transcript]',
        document,
    );
    videoTranscripts.forEach(initVideoTranscriptControl);
}

function initVideoTranscriptControl(detailsEl) {
    const summaryEl = detailsEl.querySelector('[data-summary]');

    querySelectArray('[data-progressive-enhance]', detailsEl).forEach(el =>
        el.classList.remove('u-hide'),
    );

    const openEl = detailsEl.querySelector(
        '[data-video-transcript-control-open]',
    );
    const closeEl = detailsEl.querySelector(
        '[data-video-transcript-control-close]',
    );

    const transcriptBody = detailsEl.querySelector(
        '[data-video-transcript-body]',
    );

    const transcriptFooter = detailsEl.querySelector(
        '[data-video-transcript-footer]',
    );

    summaryEl.addEventListener('click', onClickToggle, false);
    transcriptFooter.addEventListener('click', onClickToggle, false);
    summaryEl.addEventListener('keydown', onKeyDown, false);

    let state = {
        isOpen: false,
    };

    render();

    function onClickToggle(e) {
        e.preventDefault();
        toggleTranscriptionExpansion();
    }

    function onKeyDown(e) {
        if ([KEYS.ENTER, KEYS.SPACE].indexOf(e.keyCode) !== -1) {
            e.preventDefault();
            toggleTranscriptionExpansion();
        }
    }

    function toggleTranscriptionExpansion() {
        state = {
            ...state,
            isOpen: !state.isOpen,
        };
        render();
    }

    function render() {
        detailsEl.setAttribute('open', state.isOpen);
        summaryEl.setAttribute('aria-expanded', state.isOpen);
        transcriptBody.style.display = state.isOpen ? 'flex' : 'none';
        transcriptFooter.style.display = state.isOpen ? 'flex' : 'none';
        openEl.style.display = !state.isOpen ? 'flex' : 'none';
        closeEl.style.display = state.isOpen ? 'flex' : 'none';
    }
}

document.addEventListener('pjax:complete', InitVideos);

export default InitVideos;
